import { BarrelIcon } from './BarrelIcon';

/**
 * author: Google
 * id CD3098D2-892F-49F5-9FA7-1A5FDC53A15C
 * name barrel
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/barrel.svg
 * tags
 */
export const OilBarrelIcon = BarrelIcon;
export default OilBarrelIcon